export default __webpack_public_path__ + "static/media/Tiktok.5ab76fc8.svg";